export const FIRST_PROMOTER_SIGN_UP = 'API_FIRST_PROMOTER_SIGN_UP';
export const FIRST_PROMOTER_SIGN_UP_SUCCEEDED = 'API_FIRST_PROMOTER_SIGN_UP_SUCCEEDED';
export const FIRST_PROMOTER_SIGN_UP_FAILED = 'API_FIRST_PROMOTER_SIGN_UP_FAILED';
